import React, { useCallback } from "react";
import VirtualizedList, { VirtualizedListItem } from "../virtualized-list/VirtualizedList";
import { CheckListItem } from "./CheckListItem";
import { NumericalFunctionEnum } from "../../common/enums/NumericalFunctionEnum";
import { OptionalColumnEnum } from "../../common/enums/DRCXEnums";

export type CheckListItemType = {
    key: string;
    displayText: string;
    secondaryText?: string;
    tertiaryText?: string;
    checked: boolean;
    order?: number;
    id?: number
    disabled?: boolean;
    active: boolean;
    avatar?: React.ReactNode;
    summaryFunction?: NumericalFunctionEnum;
    optionalColumn?: OptionalColumnEnum
} & VirtualizedListItem;

export type CheckListProps = {
    items: Array<CheckListItemType>;
    onItemClick: (item: CheckListItemType) => void;
    filter?: (item: CheckListItemType) => boolean;
    icon?: React.ReactNode;
    checkedIcon?: React.ReactNode;
    showID?: boolean;
};

export function CheckList(
    {
        items,
        onItemClick,
        filter,
        icon,
        checkedIcon,
        showID
    }: CheckListProps) {

    const renderItem = useCallback((index: number, item: CheckListItemType) => {
        return (
            <CheckListItem
                id={index.toString()}
                key={index}
                displayText={item.displayText}
                secondaryText={item.secondaryText}
                tertiaryText={item.tertiaryText}
                onClick={() => onItemClick({ ...item, checked: !item.checked })}
                checked={item.checked}
                icon={icon}
                checkedIcon={checkedIcon}
                disabled={item.disabled}
                active={item.active}
                avatar={item.avatar}
                objectID={showID ? item.id : undefined}
            />
        );
    },
        [
            checkedIcon,
            icon,
            onItemClick,
            showID
        ]);

    return (
        <VirtualizedList
            items={items}
            renderItem={renderItem}
            filter={filter}
        />
    );
}


